import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { InEstateSummaryDTO, OutOfEstateSummaryDTO } from '../../../../api/useBalanceSheetQuery';
import { AssetsCard } from '../../components/AssetsCard/AssetsCard';
import { Owner } from '../../components/Owner/Owner';
import { Table } from '../../components/Table/Table';
import { DEFAULT_TITLE_MAP } from '../../DetailNetWorth.meta';

interface Props {
  data: {
    inEstateSummary: InEstateSummaryDTO;
    outOfEstateSummary: OutOfEstateSummaryDTO;
  };
}

export const Details = ({ data }: Props) => {
  const { inEstateSummary, outOfEstateSummary } = data;

  return (
    <Box display="flex" flexDirection="column" css={({ theme }) => ({ gap: theme.space['32'] })}>
      {inEstateSummary && <InEstateContent inEstateSummary={inEstateSummary} />}

      {outOfEstateSummary && <OutOfEstateContent outOfEstateSummary={outOfEstateSummary} />}
    </Box>
  );
};

interface InEstateContentProps {
  inEstateSummary: InEstateSummaryDTO;
}

const InEstateContent = ({ inEstateSummary }: InEstateContentProps) => {
  return (
    <Box mb="24">
      <Text fontSize="h3" fontWeight={600} mb="24">
        In-Estate Details
      </Text>

      <Box mb="24">
        <AssetsCard title={DEFAULT_TITLE_MAP.InEstate} {...inEstateSummary} />
      </Box>

      <Box mb="24">
        <Table variant="InEstate" tableData={inEstateSummary.table} />
      </Box>

      {inEstateSummary.owners.length > 0 && (
        <Box
          display="flex"
          justifyContent="center"
          flexWrap="wrap"
          css={({ theme }) => ({
            gap: theme.space['32'],
            'page-break-inside': 'avoid',
            breakInside: 'avoid',
          })}
        >
          {inEstateSummary.owners.map(
            ({ name, percentage, type, value, valueLabel, color }, index) => (
              <Owner
                key={index}
                name={name}
                valueLabel={valueLabel}
                value={value}
                type={type}
                percentage={percentage}
                color={color}
              />
            ),
          )}
        </Box>
      )}
    </Box>
  );
};

interface OutOfEstateContentProps {
  outOfEstateSummary: OutOfEstateSummaryDTO | null;
}
const OutOfEstateContent = ({ outOfEstateSummary }: OutOfEstateContentProps) => {
  if (!outOfEstateSummary) {
    return null;
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      css={({ theme }) => ({
        gap: theme.space['24'],
        pageBreakInside: 'avoid',
        breakInside: 'avoid',
      })}
    >
      <Box>
        <Text fontSize="h3" fontWeight={600}>
          Out-of-Estate Assets
        </Text>
      </Box>

      <AssetsCard title={DEFAULT_TITLE_MAP.OutsideEstate} {...outOfEstateSummary} />

      <Table variant="OutsideEstate" tableData={outOfEstateSummary.table} />
    </Box>
  );
};
